module.exports = __webpack_public_path__ + "img/pdf-label-ru.e54cf168.jpg";